import { render, staticRenderFns } from "./MantenedorTipoUbicacionBase.vue?vue&type=template&id=e300d49a&"
import script from "./MantenedorTipoUbicacionBase.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTipoUbicacionBase.vue?vue&type=script&lang=ts&"
import style0 from "./MantenedorTipoUbicacionBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports